import {
    GET_ALL_FAVORITE_LOCATIONS,
    CREATE_FAVORITE_LOCATION,
    UPDATE_FAVORITE_LOCATION,
    DELETE_FAVORITE_LOCATION,
    PROCESS_FAVORITES_FROM_DIRECTIVE
} from '../actions/favoriteLocationActions';
import ngDeps from '../utilities/ngDependencies';

const initialState = {
    favoriteLocations: [],
    favoriteLocationsIsLoading: false,
    favoriteLocationsIsUpdating: false,
    lastError: undefined
};

export function favoriteLocations(state = initialState, action) {
    switch (action.type) {
        case GET_ALL_FAVORITE_LOCATIONS.pending:
        {
            return {
                ...state,
                favoriteLocationsIsLoading: true
            };
        }
        case GET_ALL_FAVORITE_LOCATIONS.fulfilled:
        {
            // TECHDEBT: figure out why angular sets it's own values of favorite locations on page page load differently
            // mostly (after having set new favorite locations, closing browser
            // and reopening) - angular seems off with returned values for favorite locations
            ngDeps.user.FavoriteLocations = action.payload;
            return {
                ...state,
                lastError: undefined,
                favoriteLocationsIsLoading: false,
                favoriteLocations: action.payload
            };
        }
        case GET_ALL_FAVORITE_LOCATIONS.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                favoriteLocationsIsLoading: false
            };
        }
        case CREATE_FAVORITE_LOCATION.pending:
        {
            return {
                ...state,
                favoriteLocationsIsLoading: true
            };
        }
        case CREATE_FAVORITE_LOCATION.fulfilled:
        {
            let favoriteLocations;
            if (!state.favoriteLocations.some(location => location.Id === action.payload.Id)) {
                favoriteLocations = [...state.favoriteLocations, action.payload];
            } else {
                favoriteLocations = [...state.favoriteLocations];
            }

            return {
                ...state,
                lastError: undefined,
                favoriteLocationsIsLoading: false,
                favoriteLocations
            };
        }
        case CREATE_FAVORITE_LOCATION.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                favoriteLocationsIsLoading: false
            };
        }
        case UPDATE_FAVORITE_LOCATION.pending:
        {
            return {
                ...state,
                favoriteLocationsIsUpdating: true
            };
        }
        case UPDATE_FAVORITE_LOCATION.fulfilled:
        {
            const favoriteLocations = state.favoriteLocations.filter(x => x.Id !== action.payload.Id);
            favoriteLocations.push(action.payload);

            return {
                ...state,
                lastError: undefined,
                favoriteLocationsIsUpdating: false,
                favoriteLocations
            };
        }
        case UPDATE_FAVORITE_LOCATION.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                favoriteLocationsIsUpdating: false
            };
        }
        case DELETE_FAVORITE_LOCATION.pending:
        {
            return {
                ...state,
                favoriteLocationsIsLoading: true
            };
        }
        case DELETE_FAVORITE_LOCATION.fulfilled:
        {
            const favoriteLocations = state.favoriteLocations.filter(x => x.Location.Locality.CityId !== action.payload.Locality.CityId);

            return {
                ...state,
                lastError: undefined,
                favoriteLocationsIsLoading: false,
                favoriteLocations
            };
        }
        case DELETE_FAVORITE_LOCATION.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                favoriteLocationsIsLoading: false
            };
        }
        case PROCESS_FAVORITES_FROM_DIRECTIVE:
        {
            return {
                ...state,
                favoriteLocations: action.payload
            };
        }
        default: {
            return state;
        }
    }

}
